/**
 * RemusHeroSounds — Hero-Audio-Player für REMUS Produkte.
 * Wird PROMINENT oben auf der Produktseite gerendert, ersetzt die alte
 * "Sound-Beispiele" Link-Liste in der Beschreibung.
 */
import React from 'react';
import { Volume2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

function absUrl(u) {
  if (!u) return '';
  if (/^https?:\/\//i.test(u)) return u;
  if (u.startsWith('/')) return API + u;
  return u;
}

export default function RemusHeroSounds({ product }) {
  const sounds = Array.isArray(product?.sound_files) ? product.sound_files : [];
  if (sounds.length === 0) return null;

  return (
    <section
      className="remus-hero-sounds"
      data-testid="remus-hero-sounds"
      style={{
        margin: '0 0 24px',
        padding: '20px 24px',
        background: 'linear-gradient(135deg, #1a0a0a 0%, #0a0a0a 60%)',
        border: '1px solid #2a1414',
        borderLeft: '3px solid #EC2229',
        borderRadius: 8,
      }}
    >
      <div style={{
        display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14,
      }}>
        <Volume2 size={22} color="#EC2229" />
        <h2 style={{
          margin: 0, fontSize: '1.05rem', fontWeight: 700, color: '#fff',
          textTransform: 'uppercase', letterSpacing: 1,
        }}>
          Sound-Vorschau ({sounds.length})
        </h2>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        {sounds.map((s, i) => (
          <div key={i} data-testid={`remus-hero-sound-${i}`}>
            <p style={{
              margin: '0 0 6px', color: '#cfcfcf', fontSize: 13,
              fontWeight: 500,
            }}>
              {s.name || `Sound ${i + 1}`}
            </p>
            <audio
              controls
              preload="none"
              src={absUrl(s.url)}
              data-testid={`remus-hero-audio-${i}`}
              style={{ width: '100%', maxWidth: 640 }}
            >
              Dein Browser unterstützt kein Audio-Element.
            </audio>
          </div>
        ))}
      </div>
    </section>
  );
}
